var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3975 15.1747C17.3975 16.0421 18.1007 16.7453 18.968 16.7453C19.8354 16.7453 20.5386 16.0421 20.5386 15.1747C20.5386 14.3073 19.8354 13.6041 18.968 13.6041C18.1007 13.6041 17.3975 14.3073 17.3975 15.1747Z",
    stroke: "black",
    strokeWidth: 1.57056
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4341 8.89249C20.5028 8.55418 20.5388 8.20403 20.5388 7.84544C20.5388 4.95412 18.1949 2.61023 15.3036 2.61023C12.4123 2.61023 10.0684 4.95412 10.0684 7.84544C10.0684 8.20403 10.1044 8.55418 10.1731 8.89249",
    stroke: "black",
    strokeWidth: 1.57056
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97447 8.88544H17.3979C20.3593 8.88544 21.84 8.88544 22.7601 9.8059C23.6801 10.7264 23.6801 12.2078 23.6801 15.1707V17.2658C23.6801 20.2287 23.6801 21.7102 22.7601 22.6307C21.84 23.5511 20.3593 23.5511 17.3979 23.5511H11.1156C7.16695 23.5511 5.19264 23.5511 3.96594 22.3239C2.73926 21.0965 2.73926 19.1213 2.73926 15.1707V13.0757C2.73926 9.12508 2.73926 7.1498 3.96594 5.92252C4.9534 4.93459 6.4253 4.74192 9.02152 4.70435H11.1156",
    stroke: "black",
    strokeWidth: 1.57056,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletx);
export default __webpack_public_path__ + "static/media/walletx.8466ac3abfecc25a8da091f619b90fbd.svg";
export { ForwardRef as ReactComponent };